import { useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { FinancialSummary } from '@/pages/program_purse_settings/purse-details/_components/financial-summary.tsx'
import { ProgramPurseResource } from '@/queries/program_purses/schemas.ts'

interface OutletContext {
  purse: ProgramPurseResource
}

export function FinancialTabLoader() {
  const { purse } = useOutletContext<OutletContext>()
  const programId = useSelector(selectSelectedProgram).id

  return <FinancialSummary purse={purse} programId={programId} />
}
